import React, { useContext, useEffect, useState } from 'react';
import styles from './PostList.module.scss';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faHeart } from '@fortawesome/free-regular-svg-icons';
import { NavLink } from 'react-router-dom';
import routes from '~/configs';
import { BASE_URL_IMG, postData } from '~/helper/apiService';
import Controller from '../Controller';
import { ModalOverLayContext } from '../Context/ModalOverLayProvider';
import EditPost from '../EditPost';
import ConfirmModal from '../ConfirmModal';
import { FetchDataContext } from '../Context/FetchDataProvider';
import { ToastContext } from '../Context/ToastProvider';
import { LoginContext } from '../Context/LoginProvider';
import PostDetail from '../PostDetail';

const cx = classNames.bind(styles);

function PostItem({ post, handleLike }) {
  const { setModalComponentContent } = useContext(ModalOverLayContext);
  const { loadPosts } = useContext(FetchDataContext);
  const { addToast } = useContext(ToastContext);
  const { loginStatus } = useContext(LoginContext);
  const [like, setLike] = useState(0);

  const [imageLoaded, setImageLoaded] = useState(false);

  const handleEdit = (e) => {
    e.preventDefault();
    setModalComponentContent(<EditPost id={post.id} />);
  };

  const handleConfirmDelete = async () => {
    const formData = new FormData();
    formData.append('id', post.id);
    const res = await postData('/post/delete', formData);
    if (res.status === 'success') {
      loadPosts();
      setModalComponentContent(null);
    } else {
      addToast(res);
    }
  };
  const handleCancelDelete = () => {
    setModalComponentContent(null);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setModalComponentContent(
      <ConfirmModal
        title="Xác nhận xóa bài viết"
        handleConfirm={handleConfirmDelete}
        handleCancel={handleCancelDelete}
      />,
    );
  };
  if (!handleLike) {
    handleLike = async () => {
      const formData = new FormData();
      formData.append('id', post.id);
      const res = await postData('/post/like', formData);
      if (res.status === 'success') {
        setLike((prev) => parseInt(prev) + 1);
      } else {
        addToast(res);
      }
    };
  }

  useEffect(() => {
    setLike(post.likes);
  }, []);

  const handlePostClick = () => {
    setModalComponentContent(<PostDetail id={post.id} />);
  };

  return (
    <div key={post.id} className={cx('post', 'show')}>
      <div className={cx('post-item')}>
        {loginStatus && <Controller className={cx('controller')} handleEdit={handleEdit} handleDelete={handleDelete} />}
        <div
          // to={`${routes.postDetail}/${post.id}`}
          className={cx('post-nav')}
          onClick={handlePostClick}
        >
          {post.img && (
            <div className={cx('post-image-wrapper')}>
              {!imageLoaded && <div className={cx('image-skeleton')} />}
              <img
                src={BASE_URL_IMG + '/' + post.img}
                alt="Post"
                className={cx('post-image', { loaded: imageLoaded })}
                loading="lazy"
                onLoad={() => {
                  setImageLoaded(true);
                }}
              />
            </div>
          )}

          <h2 className={cx('post-title')}>{post.title}</h2>
          <p className={cx('post-content')}>{post.content}</p>
        </div>
        <div className={cx('post-meta')}>
          <div className={cx('post-meta-box')}>
            <p className={cx('comment-box')}>
              <FontAwesomeIcon className={cx('icon')} icon={faHeart} onClick={handleLike} />
              <span className={cx('text')}>{like}</span>
            </p>
            <p className={cx('comment-box')}>
              <FontAwesomeIcon className={cx('icon')} icon={faComment} />
              <span className={cx('text')}>{post.comment_count}</span>
            </p>
          </div>
          <p className={cx('post-more')}>{post.date_create}</p>
        </div>
      </div>
    </div>
  );
}

export default PostItem;
